namespace membership {
    $(document).ready(() => {
        var formInputSelector = "form > .form-group";
        var submitButtonSelector = "input[type='submit']";
        var reCaptchaSelector = ".g-recaptcha";
        var originalTextSubmitButton = $(submitButtonSelector).prop('value');

        $("#loginBox #aaf-radio-button").click(() => {
            $(formInputSelector).hide();
            $(reCaptchaSelector).hide();
            $(submitButtonSelector).prop('value', 'Continue');
            $(submitButtonSelector).click((event: any) => {
                event.preventDefault();
                var aafUrl = (<any>window).checkApp.aafUrl;
                if (aafUrl) {
                    window.location.href = aafUrl;
                } else {
                    console.log("aaf variable not set properly");
                }
            });
        });

        $(".logout-button").click((event: any) => {
            $(event.target).closest('form').submit();
        });

        $("#loginBox #checkapp-account-radio-button ").click(() => {
            $(formInputSelector).show();
            $(reCaptchaSelector).show();
            $(submitButtonSelector).prop('value', originalTextSubmitButton);
            $(submitButtonSelector).unbind('click');
        });


    });
}